import { create } from 'zustand';

type UseHubSpotChatStore = {
  hideChat: () => void;
  isLoading: boolean;
  isOpen: boolean;
  showChat: () => void;
  unreadCount: number;
  onUnreadConversationCountChanged: (payload: { unreadCount?: number }) => void;
  onWidgetReady: () => void;
};

export const useHubSpotChatStore = create<UseHubSpotChatStore>((set, get) => ({
  hideChat: () => {
    if (window.HubSpotConversations && get().isOpen) {
      window.HubSpotConversations.widget.close();
      set({ isOpen: false });
    } else {
      console.error('HubSpot Conversations is not loaded');
    }
  },
  isLoading: true,
  isOpen: false,
  showChat: () => {
    if (window.HubSpotConversations) {
      window.HubSpotConversations.widget.open();
      set({ isOpen: true });
    } else {
      console.error('HubSpot Conversations is not loaded');
    }
  },
  unreadCount: 0,
  onUnreadConversationCountChanged: ({ unreadCount = 0 }) => {
    set((state) => ({ ...state, isOpen: state.isOpen || unreadCount > 0, unreadCount }));
  },
  onWidgetReady: () => set({ isLoading: false }),
}));

export const showChat = () => useHubSpotChatStore.getState().showChat();
export const hideChat = () => useHubSpotChatStore.getState().hideChat();
